import { formatISO } from 'date-fns'

import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import {
  OnboardingFail,
  OnboardingPartnerFlagServiceMethods,
  OnboardingResponse,
  OnboardingServices,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import {
  IPartnerFlag,
  PartnerFlagRequestAction,
  TPartherFlagRequest,
  TPartnerFlagResponse,
} from '../../models'
import { invalidatePartnerFlagsCache } from '../cache'

export async function createPartnerFlagRequest(partnerFlag: IPartnerFlag) {
  const payload: TPartherFlagRequest = {
    Action: partnerFlag.action || PartnerFlagRequestAction.Add,
    Caption: partnerFlag.caption,
    Code: partnerFlag.code,
    CodeName: partnerFlag.codeName,
    Comment: partnerFlag.comment,
    Country: partnerFlag.country,
    EndDate: formatISO(partnerFlag.endDate, { representation: 'date' }),
    Market: partnerFlag.market,
    PartnerId: partnerFlag.partnerId,
    StartDate: formatISO(partnerFlag.startDate, { representation: 'date' }),
    Source: ProfilingRequestSource.ClickAndGo,
    Type: partnerFlag.codeType,
  }

  const token = getAccessToken() || ''
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  const response = (await wsClient.call({
    service: OnboardingServices.PartnerFlag,
    action: OnboardingPartnerFlagServiceMethods.Save,
    payload,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
    token,
  })) as OnboardingResponse<OnboardingFail, TPartnerFlagResponse>

  invalidatePartnerFlagsCache(partnerFlag.partnerId)

  return response
}
